import { render } from "./estimated-electric-costs.vue?vue&type=template&id=c660a4a4"
import script from "./estimated-electric-costs.vue?vue&type=script&lang=js"
export * from "./estimated-electric-costs.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__